import 'sass/blocks/_age-restriction.scss';
import 'sass/blocks/_resident-restriction.scss';
import 'sass/blocks/_dni-deny.scss';
import 'sass/blocks/_password-requirements.scss';
import 'sass/blocks/_initial-step.scss';
import 'sass/animations.scss';

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-redux-form';
import { history } from 'routes/history';
import postscribe from 'postscribe';
import cryptoJS from 'crypto-js';
import validator from 'validator';
import { birthYearMatchesPassword, birthDayMatchesPassword } from 'commonsUtilities/validations';
import { formatText, FormattedText } from 'core/i18n';
import Storage from 'utilities/storage';
import scroll from 'utilities/scroll';
import {
    getReferenceOptionsDocumentTypeByCountry,
    getReferenceOptionsTreatmentByCountry,
    getAliasesDocumentType,
    isCountrySpain,
} from 'utilities/multiLanguageHelper';

import md5 from 'js-md5';
import {
    mustIncludeTinToRequest,
    mustShowInfoAnotherAccount,
    mustShowTreatmentFields,
    showForm,
} from 'utilities/logicByCountry';
import { isRealYear } from 'utilities/dateHelper/dateHelper';
import { checkConditionAndExecuteCallback } from 'utilities/toggling';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import { identifyOnboardingTypeByPath } from 'utilities/onboardingTypeHelper';
import ResidentContainer from '../residentContainer';
import OlderContainer from '../olderContainer';
import JointHolderContainer from '../jointHolderContainer';
import { ID } from './ID/ID';
import { Name } from '../fields/Name/Name';
import { LastName } from '../fields/LastName/LastName';
import { SecondLastName } from '../fields/SecondLastName/SecondLastName';
import { BirthDate } from '../fields/BirthDate/BirthDate';
import { Password } from './Password/Password';
import { Resident } from '../fields/Resident/Resident';
import { Email } from '../fields/Email/Email';
import ModalBox from 'components/modalBox/modalBox';
import { LegalInfo } from '../legalInfo/legalInfo';
import Headline from 'components/headline';
import CheckBox from 'components/checkBox/checkBox';
import { Documentation } from '../documentation/Documentation';
import AlertWarning from 'components/modalOtpUniversia/components/components/alertWarning';
import { PUBLICA_URL, BASE_PATH, LOGIN_DESKTOP, LOGIN_MOBILE } from 'constants/index';
import { COUNTRY_DOCUMENT_TYPE_DNI } from 'constants/multiLanguage';
import { ML2 } from 'constants/featureFlagging';
import { CREDIT_CARD } from 'constants/userProfile';
import { useComponentWillMount } from 'hooks/useComponentWillMount';
import { MAX_VALID_AGE, MIN_VALID_AGE } from 'components/newAccountSteps/initialStep/constants';
import { isMobile } from 'utilities/browser';
import {
    doTagErrorIncorrectRegister,
    doTagInvalidBirthday,
    doTagInvalidProduct,
    doTagErrorRequiredFields,
    doTagValidationFieldRequired,
    doTagValidateBirthday,
    doTagSendRecoverTag,
} from '../tagging';
import { Treatment } from 'components/newAccountSteps/initialStep/fields/Treatment/Treatment';
import { useSaveRegisterRequests } from 'components/newAccountSteps/initialStep/useSaveRegisterRequests';
import {
    doTagBirthDay,
    doTagBirthMonth,
    doTagBirthYear,
    doTagID,
    doTagIsResident,
    doTagLastName,
    doTagName,
    doTagSecondLastName,
    doTagTin,
} from '../sections/PersonalData/tagging';

export const InitialStepFormComponent = ({
    formActions,
    actions,
    userProfile,
    immStepsState,
    productsActions,
    promoCode,
    userProfileForm,
    promotionalCode,
    focus,
    focusActions,
    readyCaptchaToken,
    preLoaderActions,
    renderTermsAndConditions,
    scoringActions,
    wealthProduct,
    flags,
    products,
}) => {
    const [emailConfirmation, setEmailConfirmation] = useState(false);
    const [hiddenJointHolderContainer, setHiddenJointHolderContainer] = useState(true);
    const [hiddenOlderContainer, setHiddenOlderContainer] = useState(true);
    const [hiddenResidentContainer, setHiddenResidentContainer] = useState(true);
    const [idValid, setIdValid] = useState(false);
    const [isBirthDateGroupValidate, setIsBirthDateGroupValidate] = useState(false);
    const [isNameGroupValidate, setIsNameGroupValidate] = useState(false);
    const [isReaded, setIsReaded] = useState(false);
    const [isResident, setIsResident] = useState(false);
    const [isValidDate, setIsValidDate] = useState(true);
    const [onSubmit, setOnSubmit] = useState({ disabled: 'disabled' });
    const [isValidPass, setIsValidPass] = useState(false);
    const [pressTabSecondLastname, setPressTabSecondLastname] = useState(false);
    const [showContinueBar, setShowContinueBar] = useState(true);
    const [showEmailDisclaimer, setShowEmailDisclaimer] = useState(false);
    const [showLastNameDisclaimer, setShowLastNameDisclaimer] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const documentsRef = useRef(null);
    const emailConfirmationRef = useRef(null);

    useComponentWillMount(() => {
        let jointholder;
        let universia;
        const initialStepComplete = immStepsState.get('initialStepComplete');

        if (initialStepComplete) {
            history.push(`${BASE_PATH}/steps`);
        }
        if (userProfile.universiaName) {
            universia = {
                docType: userProfile.docType,
                docNumber: userProfile.docNumber,
                name: userProfile.name,
                lastName: userProfile.lastName,
                email: userProfile.email,
                birthDay: userProfile.birthDay,
                birthMonth: userProfile.birthMonth,
                birthYear: userProfile.birthYear,
                birthDate: userProfile.birthDate,
                documentType: userProfile.documentType,
                universiaName: userProfile.universiaName,
                town: userProfile.town,
                country: userProfile.country,
                gender: userProfile.gender,
                cellPhone: userProfile.cellPhone,
                cellPhoneConfirmation: userProfile.cellPhoneConfirmation,
                cellphonePrefix: userProfile.cellphonePrefix,
            };
        }
        if (userProfile.jointHolderForm) {
            jointholder = {
                jointHolderData: userProfile.jointHolderData,
                isJointHolder: true,
                isJointHolderNoClient: userProfile.isJointHolderNoClient,
                jointHolderForm: true,
            };
        }

        if (
            !userProfile.iban &&
            !userProfile.isJointHolder &&
            !userProfile.productType &&
            !userProfile.productSubtype &&
            !userProfile.productStandard
        ) {
            formActions.reset('userProfile');
        }

        formActions.change('userProfile.documentType', getReferenceOptionsDocumentTypeByCountry()[0].value);
        formActions.change('userProfile.treatment', getReferenceOptionsTreatmentByCountry()[0].value);

        formActions.change('userProfile.isOlder', true);

        if (universia) {
            formActions.change('userProfile.documentType', universia.docType);
            formActions.change('userProfile.docNumber', universia.docNumber);
            formActions.change('userProfile.docNumberDisabled', true);
            formActions.change('userProfile.name', universia.name);
            formActions.change('userProfile.lastName', universia.lastName);
            formActions.change('userProfile.email', universia.email);
            formActions.change('userProfile.emailConfirmation', universia.email);
            formActions.change('userProfile.birthDay', universia.birthDay);
            formActions.change('userProfile.birthMonth', universia.birthMonth);
            formActions.change('userProfile.birthYear', universia.birthYear);
            formActions.change('userProfile.birthDate', universia.birthDate);
            formActions.change('userProfile.birthDayDisabled', true);
            formActions.change('userProfile.documentType', universia.documentType);
            formActions.change('userProfile.universiaName', universia.universiaName);
            formActions.change('userProfile.town', universia.town);
            formActions.change('userProfile.country', universia.country);
            formActions.change('userProfile.gender', universia.gender);
            formActions.change('userProfile.cellPhone', universia.cellPhone);
            formActions.change('userProfile.cellPhoneConfirmation', universia.cellPhone);
            formActions.change('userProfile.cellphonePrefix', universia.cellphonePrefix);
            formActions.change('userProfile.cellPhoneDisabled', true);
            formActions.change('userProfile.jointHolderDecision', 'false');
            setIsBirthDateGroupValidate(true);
            setIsValidPass(true);
            setIsValidDate(true);
            setEmailConfirmation(true);
            setIdValid(true);
        }

        let promoCodeValue = promoCode;
        if (jointholder) {
            formActions.change('userProfile.jointHolderData', jointholder.jointHolderData);
            formActions.change('userProfile.isJointHolder', jointholder.isJointHolder);
            formActions.change('userProfile.isJointHolderNoClient', jointholder.isJointHolderNoClient);
            formActions.change('userProfile.jointHolderForm', jointholder.jointHolderForm);
            formActions.change('userProfile.jointHolderType', jointholder.jointHolderData.invite.jointHolderType);
            formActions.change('userProfile.openDebitCard', jointholder.jointHolderData.invite.openDebitCard);
            formActions.change('userProfile.isJointHolderAccount', true);
            formActions.change('userProfile.jointHolderDecision', 'false');
            promoCodeValue = jointholder.jointHolderData.invite.promoCode;
        }

        if (typeof userProfile.acceptTerms !== 'undefined') {
            userProfile.acceptTerms ? setOnSubmit({}) : setOnSubmit({ disabled: 'disabled' });
        }
        if (promoCodeValue) {
            formActions.change('userProfile.promoCode', promoCodeValue);
        }

        if (actions.cancelOnBoardingProcess()) {
            setShowModal(true);
        }
        if (!jointholder && !promoCodeValue) {
            productsActions.getProducts((valid, error) => {
                if (!valid) {
                    doTagInvalidProduct(error);
                }
            });
        }
    });

    const validateDocNumberJointHolder = (docType, docNumber) => {
        const { jointHolderData } = userProfile;
        const isResident = !(
            typeof userProfileForm.resident !== 'undefined' && userProfileForm.resident.value === 'false'
        );

        if (userProfile.jointHolderForm) {
            const doc = md5(getAliasesDocumentType(docType) + docNumber);
            const jointHolderDocument = jointHolderData.invite.doc;
            const idMatchesJointHolderDocument = doc === jointHolderDocument;
            if (!idMatchesJointHolderDocument) {
                setHiddenOlderContainer(true);
                setHiddenResidentContainer(true);
                const JointHolderContainerElement = document.getElementById('JointHolderContainer');
                scroll.transition(JointHolderContainerElement, 'top');
            } else {
                setHiddenOlderContainer(userProfile.isOlder);
                setHiddenResidentContainer(!userProfile.isOlder ? true : isResident);
                if (!userProfile.isOlder) {
                    const ageDisclosureElement = document.getElementById('ageRestriction');
                    scroll.transition(ageDisclosureElement, 'top');
                } else {
                    const residentDisclosureElement = document.getElementById('countryRestriction');
                    scroll.transition(residentDisclosureElement, 'top');
                }
            }
            setHiddenJointHolderContainer(idMatchesJointHolderDocument);
            setShowContinueBar(idMatchesJointHolderDocument && userProfile.isOlder && isResident);
        }
    };

    useEffect(() => {
        if (!userProfileForm.$form.valid && focus.get('triggerValidations')) {
            const errorElements = document.getElementsByClassName('valid-error');
            if (errorElements.length > 0) {
                const input = errorElements[0].getElementsByTagName('input')[0];
                if (typeof input !== 'undefined') {
                    scroll.transition(input, 'top');
                    setTimeout(() => {
                        input.focus();
                    }, 500);
                } else {
                    focusActions.setFocusForm(errorElements[0].id);
                    const element = errorElements[0];
                    scroll.transition(element);
                }
            }
            focusActions.triggerValidations(false);
        }
    }, [focus]);

    useEffect(() => {
        if (userProfileForm?.docNumber?.valid) {
            validateDocNumberJointHolder(userProfile.documentType, userProfile.docNumber);
        }
    }, [userProfileForm.docNumber]);

    const resetDocuments = () => {
        formActions.change('userProfile.precontractualDocsOK', false);
        formActions.change('userProfile.saveTimeDocAccept', []);
        formActions.change('userProfile.acceptedText', '');
        formActions.change('userProfile.precontractualDocsId', '');
    };

    const submitButtonValidations = (condition = true) => {
        const passwordValidations = isValidPass && userProfile.password && userProfile.password !== '';
        const emailValidations =
            emailConfirmation && userProfile.emailConfirmation && userProfile.emailConfirmation !== '';
        let needsTinValidation = false;

        if (isCountrySpain()) {
            needsTinValidation = true;
        } else {
            needsTinValidation = userProfileForm.tin && userProfileForm.tin.valid;
        }

        let isResidentValid = true;

        isResidentValid = userProfile.universiaName ?? isResident;

        if (
            isNameGroupValidate &&
            isBirthDateGroupValidate &&
            passwordValidations &&
            isValidDate &&
            (isResidentValid || userProfile.investmentType === CREDIT_CARD) &&
            isReaded &&
            emailValidations &&
            idValid &&
            needsTinValidation &&
            condition
        ) {
            setOnSubmit({});
        } else {
            setOnSubmit({ disabled: 'disabled' });
        }
    };

    useEffect(() => {
        submitButtonValidations();
    }, [isReaded, idValid, isResident, isValidPass, isNameGroupValidate, isBirthDateGroupValidate]);

    const handleReaded = option => {
        setIsReaded(option);
    };

    useEffect(() => {
        if (!promotionalCode?.get('promotionalCode').get('code')) {
            formActions.change('userProfile.onboardingType', identifyOnboardingTypeByPath(window.location.pathname));
        }
    }, [promotionalCode]);

    useEffect(() => {
        if (userProfile.onboardingType) {
            actions.getPrecontractualDocumentNames(
                userProfile.onboardingType,
                userProfile.jointHolderData?.invite.openDebitCard
            );
            resetDocuments();
            handleReaded(false);
        }
    }, [userProfile.onboardingType]);

    const getDocuments = (onboardingType, callback) => {
        const url = promotionalCode?.get('promotionalCode').get('url');
        const infoArray = [formatText('button-contractWait'), formatText('button-preContractGenerating')];

        preLoaderActions.setInformationArray(infoArray);
        preLoaderActions.showPreLoader();
        readyCaptchaToken(recaptcha => {
            actions.precontractualProcess(
                onboardingType,
                userProfile.jointHolderData?.invite.openDebitCard,
                url,
                callback,
                recaptcha
            );
        });
    };

    const validateAllRequiredFields = data => {
        const { investmentType, docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const requiredFields = [
            'name',
            'lastName',
            'birthDate',
            'documentType',
            'docNumber',
            'email',
            'emailConfirmation',
            'password',
        ];
        let a = 0;

        const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(investmentType);
        checkConditionAndExecuteCallback(!userInvestmentType[CREDIT_CARD], () => requiredFields.push('resident'));

        if (userProfile.investmentType === CREDIT_CARD) requiredFields.push('acceptTerms');

        if (data.documentType === COUNTRY_DOCUMENT_TYPE_DNI) requiredFields.push('secondLastName');
        if (mustIncludeTinToRequest()) requiredFields.push('tin');
        let fieldsWithError = '';
        let j = 0;
        for (let i = 0; i < requiredFields.length; i++) {
            if (
                data[requiredFields[i]] !== '' &&
                typeof data[requiredFields[i]] !== 'undefined' &&
                data[requiredFields[i]] !== false
            ) {
                a++;
            } else {
                if (j === 0) {
                    fieldsWithError += requiredFields[i];
                } else {
                    fieldsWithError += `|${requiredFields[i]}`;
                }
                j++;
                formActions.setValidity(`userProfile.${requiredFields[i]}`, { required: false });
                if (requiredFields[i] === 'birthDate') {
                    formActions.setValidity('userProfile.birthDay', {
                        required: false,
                    });
                    formActions.setValidity('userProfile.birthMonth', { required: false });
                    formActions.setValidity('userProfile.birthYear', { required: false });
                }
            }
        }
        if (requiredFields.length !== a) {
            doTagErrorRequiredFields(userProfile, fieldsWithError);
            doTagErrorIncorrectRegister(userProfile, docNumberEncrypted);
        }

        focusActions.triggerValidations(true);

        return requiredFields.length === a;
    };

    // Function that recive all data before send to service and validate some fields
    const handleValidation = e => {
        e && e.preventDefault();
        validateAllRequiredFields(userProfile);
    };

    const saveDigilantData = () => {
        const pixel = document.getElementsByName('pixel');
        if (!pixel || !pixel.item('pixel')) return;
        const src = pixel.item('pixel').src;
        const cookie = src.slice(src.indexOf('uc=') + 3, src.indexOf('&r'));
        const requestId = src.slice(src.indexOf('req=') + 4, src.length);

        scoringActions.postML2(cookie, requestId, userProfile.accessToken);
    };

    const appendImgPixel = () => {
        let errorPostScribe = false;
        const div = document.createElement('div');
        document.body.appendChild(div);

        postscribe(div, '<script src="https://es.wtp101.com/pixel?id=eba455aadc2946bb"></script>', {
            done: () => {
                if (errorPostScribe) return;
                saveDigilantData();
                history.push(`${BASE_PATH}/steps`);
            },
            error: () => {
                errorPostScribe = true;
                history.push(`${BASE_PATH}/steps`);
            },
        });
    };

    const saveRegister = (flags, saved, userProfile) => {
        if (saved && userProfile.creditCardOffer_accepted && flags.get(ML2)) {
            appendImgPixel();
        } else {
            history.push(`${BASE_PATH}/steps`);
        }
    };

    const { handleSaveRequest, handleSaveNoResidentRequest } = useSaveRegisterRequests(
        flags,
        userProfile,
        actions,
        saveRegister,
        wealthProduct
    );

    const handleSubmit = () => {
        if (userProfileForm.$form.valid) {
            Storage.cookies.remove('jointHolderInvite');
            preLoaderActions.setInformationText(formatText('informationText-register'));
            preLoaderActions.showPreLoader();
            if (hiddenResidentContainer) {
                readyCaptchaToken(handleSaveRequest);
            } else {
                handleSaveNoResidentRequest();
            }
            actions.setFromInitialStep(true);
        }
    };

    const validateBirthDay = (value, type) => {
        let valid = true;
        const birthDateString = value;
        if (typeof birthDateString !== 'undefined') {
            let age;
            if (type === 'older') {
                const today = new Date();
                const birthDate = new Date(birthDateString);
                const m = today.getMonth() - birthDate.getMonth();
                age = today.getFullYear() - birthDate.getFullYear();
                if (age < MIN_VALID_AGE && age > 0) {
                    valid = false;
                } else if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                    if (age < MIN_VALID_AGE && age >= 0) {
                        valid = false;
                    }
                }
            } else if (type === 'vDate') {
                valid = validator.isDate(birthDateString);
                if (valid) {
                    const today = new Date();
                    const birthDate = new Date(birthDateString);
                    const m = today.getMonth() - birthDate.getMonth();
                    age = today.getFullYear() - birthDate.getFullYear();

                    if (age > MAX_VALID_AGE || age <= 0) {
                        valid = false;
                    } else if (m > 0 || (m === 0 && today.getDate() >= birthDate.getDate())) {
                        age++;
                        if (age > MAX_VALID_AGE || age < 0) {
                            valid = false;
                        }
                    }
                }
            }
        } else {
            valid = false;
        }

        return valid;
    };

    const handleValidateResident = isResident => {
        setHiddenResidentContainer(isResident);
        setShowContinueBar(isResident);
        if (!isResident) {
            const residentDisclosureElement = document.getElementById('countryRestriction');
            scroll.transition(residentDisclosureElement, 'top');
        }
    };

    const setBirthDayMonthValidation = (formActions, valid) => {
        formActions.setValidity('userProfile.birthDay', { required: valid });
        formActions.setValidity('userProfile.birthMonth', { required: valid });
        formActions.setValidity('userProfile.birthDate', {
            validPinBirthDate: valid,
        });
    };

    const setBirthYearValidation = (formActions, valid) => {
        formActions.setValidity('userProfile.birthYear', { required: valid });
        formActions.setValidity('userProfile.birthDate', {
            validPinBirthDate: valid,
        });
    };

    const handleValidateBirthDay = (isEmpty, checkBirthDay) => {
        const { password } = userProfile;
        const dateRegExp =
            /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/g;
        let day = userProfile.birthDay ? userProfile.birthDay : '';
        let month = userProfile.birthMonth ? userProfile.birthMonth : '';
        const year = userProfile.birthYear ? userProfile.birthYear : '';
        const isResident = !(
            typeof userProfileForm.resident !== 'undefined' && userProfileForm.resident.value === 'false'
        );
        // Validate format date
        if (day !== '' && month !== '' && year !== '') {
            const dateFormatToValidate = `${day}/${month}/${year}`;
            if (year.length < 4) {
                formActions.setValidity('userProfile.birthDate', {
                    validYearLength: false,
                });
                setIsValidDate(false);
            } else if (!dateFormatToValidate.match(dateRegExp)) {
                formActions.setValidity('userProfile.birthDate', {
                    valid: false,
                });
                setIsValidDate(false);
            } else {
                day = day.length < 2 ? `0${day}` : day;
                month = month.length < 2 ? `0${month}` : month;
                const dateString = `${year}/${month}/${day}`;
                const isOlder = validateBirthDay(dateString, 'older');
                const isValidDate = isRealYear(year) ? validateBirthDay(dateString, 'vDate') : false;
                formActions.change('userProfile.birthDate', dateString);
                formActions.setValidity('userProfile.birthDate', {
                    valid: isValidDate,
                    older: isOlder,
                });
                formActions.change('userProfile.isOlder', isOlder);
                setHiddenOlderContainer(isOlder);
                setIsValidDate(isValidDate);
                setShowContinueBar(isOlder && isResident);
                if (!isOlder) {
                    setHiddenJointHolderContainer(true);
                    setHiddenResidentContainer(true);
                    const ageDisclosureElement = document.getElementById('ageRestriction');
                    scroll.transition(ageDisclosureElement, 'top');
                } else {
                    handleValidateResident(isResident);
                }

                if (!isOlder && checkBirthDay) {
                    doTagValidateBirthday(userProfile, products);
                }

                if (isValidDate) {
                    formActions.setValidity('userProfile.birthDay', {
                        required: true,
                    });
                    formActions.setValidity('userProfile.birthMonth', {
                        required: true,
                    });
                    formActions.setValidity('userProfile.birthYear', {
                        required: true,
                    });
                } else {
                    doTagInvalidBirthday(userProfile);
                }

                birthYearMatchesPassword(password, userProfile.birthYear) && setBirthYearValidation(formActions, false);
                birthDayMatchesPassword(password, userProfile.birthDay, userProfile.birthMonth) &&
                    setBirthDayMonthValidation(formActions, false);
            }
        } else if (pressTabSecondLastname) {
            setPressTabSecondLastname(false);
        } else if (!isEmpty) {
            formActions.setValidity('userProfile.birthDate', {
                required: false,
            });
            setIsValidDate(false);
            doTagValidationFieldRequired(userProfile);
        }
    };

    const onHandleClickRedirects = () => {
        window.location.href = PUBLICA_URL;
    };

    const validateGroups = (fieldName, valid) => {
        const fields = userProfileForm;
        const value = userProfile[fieldName];
        if (fieldName === 'name' || fieldName === 'lastName' || fieldName === 'secondLastName') {
            let isNameValid = !!(fields.name && fields.name.valid);
            if (fieldName === 'name') {
                isNameValid = value !== '' ? valid : false;
            }
            let isLastNameValid = !!(fields.lastName && fields.lastName.valid);
            if (fieldName === 'lastName') {
                isLastNameValid = value !== '' ? valid : false;
            }
            if (userProfile.documentType === COUNTRY_DOCUMENT_TYPE_DNI && fieldName === 'secondLastName') {
                isLastNameValid = value !== '' ? valid : false;
            }
            setIsNameGroupValidate(isNameValid && isLastNameValid);
        }

        let checkBirthDay = false;
        let isEmpty = true;
        if (fieldName === 'birthDay' || fieldName === 'birthMonth' || fieldName === 'birthYear') {
            let isBirthDayValid = fields.birthDay && fields.birthDay.valid;
            if (fieldName === 'birthDay') {
                isBirthDayValid = value !== '' ? valid : false;
            }

            let isBirthMonthValid = fields.birthMonth && fields.birthMonth.valid;
            if (fieldName === 'birthMonth') {
                isBirthMonthValid = value !== '' ? valid : false;
            }

            let isBirthYearValid = fields.birthYear && fields.birthYear.valid;
            if (fieldName === 'birthYear') {
                isBirthYearValid = value !== '' && value.length === 4 ? valid : false;
            }

            if (isValidDate) {
                if (
                    fieldName === 'birthYear' ||
                    (userProfile.birthYear !== '' && (userProfile.birthDay === '' || userProfile.birthMonth === '')) ||
                    userProfile.birthYear === ''
                ) {
                    setIsBirthDateGroupValidate(isBirthDayValid && isBirthMonthValid && isBirthYearValid);
                    isEmpty = isBirthDayValid && isBirthMonthValid && isBirthYearValid;
                }
            } else {
                setIsBirthDateGroupValidate(isBirthDayValid && isBirthMonthValid && isBirthYearValid);
                isEmpty = false;
            }

            checkBirthDay = true;
        }
        if (pressTabSecondLastname || checkBirthDay) {
            handleValidateBirthDay(isEmpty, checkBirthDay);
        }

        submitButtonValidations();
    };

    const validateSecondLastName = value => {
        const isEmpty = !userProfile[value];
        const validationModel = `userProfile.${value}`;

        if (
            isEmpty &&
            userProfile.documentType !== COUNTRY_DOCUMENT_TYPE_DNI &&
            validationModel === 'userProfile.secondLastName'
        ) {
            formActions.setValidity(validationModel, { required: isEmpty });
            setIsNameGroupValidate(true);

            return;
        }

        if (
            userProfile.documentType !== COUNTRY_DOCUMENT_TYPE_DNI &&
            validationModel === 'userProfile.secondLastName'
        ) {
            setIsNameGroupValidate(true);

            return;
        }

        if (
            userProfile.documentType === COUNTRY_DOCUMENT_TYPE_DNI &&
            isEmpty &&
            validationModel === 'userProfile.secondLastName'
        ) {
            const { name, lastName } = userProfile;
            name && lastName ? formActions.setValidity(validationModel, { required: false }) : null;
            submitButtonValidations(false);
        }

        setIsNameGroupValidate(userProfile.documentType === COUNTRY_DOCUMENT_TYPE_DNI);
    };

    const handleShowEmailDisclaimer = show => {
        setShowEmailDisclaimer(show);
    };

    const handleShowLastNameDisclaimer = show => {
        setShowLastNameDisclaimer(show);
    };

    const renderHeadLine = promotionalCode => {
        const mobileLoginToggleString = isMobile() ? LOGIN_MOBILE : LOGIN_DESKTOP;

        if (userProfile.isJointHolder) {
            return (
                <Headline icon="cliente" className="prospects-gutter">
                    <h2>
                        <FormattedText value="initial-jointHolderOpenAccountTitle" />
                    </h2>
                </Headline>
            );
        }

        if (showForm(promotionalCode, flags.get('promoCodePassport'))) {
            return (
                <Headline icon="cliente" className="prospects-gutter prospects-initial">
                    <h2>{formatText('initial-complete')}</h2>
                    <h5>
                        <FormattedText value="initial-continueProcess" />
                        <a onClick={doTagSendRecoverTag} href={PUBLICA_URL + mobileLoginToggleString}>
                            {formatText('initial-link')}
                        </a>
                    </h5>
                </Headline>
            );
        }

        return null;
    };

    const saveTimeDocAccept = ({ dmsDocumentId, documentType, checksum }) => {
        const now = new Date();
        const newSaveTimeDocAccept = [
            ...userProfile.saveTimeDocAccept,
            { dmsDocumentId, documentType, checksum, date: now.toISOString() },
        ];
        formActions.change('userProfile.saveTimeDocAccept', newSaveTimeDocAccept);
        if (userProfile.precontractualDocNames.length === newSaveTimeDocAccept.length) handleReaded(true);
        scroll.transition(documentsRef?.current);
    };

    const scrollToDocModalRow = () => {
        scroll.transition(documentsRef?.current);
    };

    const promoFormIsVisible = flags.get('promoCodePassport');
    if (!showForm(promotionalCode, promoFormIsVisible) || !userProfile.precontractualDocNames) return null;
    const classNameButtonSubmit = !userProfile.isJointHolder
        ? 'form__button form__button-secondary'
        : 'form__button form__button-primary';

    const button = userProfile.isJointHolder ? 'button-continue' : 'button-start';

    const handleOnChangeResident = value => {
        const isValueTruthy = value === 'true';
        setIsResident(isValueTruthy);
        doTagIsResident(isValueTruthy);
    };

    return (
        <div className="prospects-step-content basic-layering" id="profileForm">
            <div className="prospects-step-content basic-layering">
                {renderHeadLine(promotionalCode)}
                <div className="initialstep-container">
                    <Form model="userProfile" onSubmit={handleSubmit} noValidate>
                        <div className="prospects-gutter prospects-separator">
                            <ID
                                userProfile={userProfile}
                                focus={focus}
                                userProfileForm={userProfileForm}
                                formActions={formActions}
                                setIdValid={setIdValid}
                                validateSecondLastName={validateSecondLastName}
                                submitButtonValidations={submitButtonValidations}
                                disabled={userProfile.docNumberDisabled}
                                onFocus={doTagID}
                            />
                            <Treatment
                                userProfile={userProfile}
                                userProfileForm={userProfileForm}
                                formActions={formActions}
                                focus={focus}
                                hidden={!mustShowTreatmentFields()}
                            />
                            <Name
                                formActions={formActions}
                                userProfile={userProfile}
                                userProfileForm={userProfileForm}
                                validateGroups={validateGroups}
                                onFocus={doTagName}
                            />
                            <LastName
                                formActions={formActions}
                                userProfile={userProfile}
                                userProfileForm={userProfileForm}
                                showDisclaimer={showLastNameDisclaimer}
                                setShowDisclaimer={handleShowLastNameDisclaimer}
                                validateGroups={validateGroups}
                                onFocus={doTagLastName}
                            />
                            <SecondLastName
                                userProfile={userProfile}
                                userProfileForm={userProfileForm}
                                formActions={formActions}
                                validateGroups={validateGroups}
                                onFocus={doTagSecondLastName}
                            />
                            <div className={hiddenJointHolderContainer ? '' : 'hidden'}>
                                <BirthDate
                                    userProfile={userProfile}
                                    userProfileForm={userProfileForm}
                                    formActions={formActions}
                                    isValidDate={isValidDate}
                                    isBirthDateGroupValidate={isBirthDateGroupValidate}
                                    validateGroups={validateGroups}
                                    onFocusBirthDay={doTagBirthDay}
                                    onFocusBirthMonth={doTagBirthMonth}
                                    onFocusBirthYear={doTagBirthYear}
                                />
                                <div className={hiddenOlderContainer ? '' : 'hidden'}>
                                    <Resident
                                        userProfile={userProfile}
                                        userProfileForm={userProfileForm}
                                        formActions={formActions}
                                        actions={actions}
                                        handleValidateResident={handleValidateResident}
                                        onChange={handleOnChangeResident}
                                        onFocusTin={doTagTin}
                                        submitButtonValidations={submitButtonValidations}
                                    />
                                    <div className={hiddenResidentContainer ? '' : 'hidden'}>
                                        <Email
                                            userProfile={userProfile}
                                            userProfileForm={userProfileForm}
                                            formActions={formActions}
                                            submitButtonValidations={submitButtonValidations}
                                            setEmailConfirmation={setEmailConfirmation}
                                            setShowEmailDisclaimer={handleShowEmailDisclaimer}
                                            showEmailDisclaimer={showEmailDisclaimer}
                                            emailConfirmationRef={emailConfirmationRef}
                                        />
                                        <Password
                                            userProfile={userProfile}
                                            userProfileForm={userProfileForm}
                                            formActions={formActions}
                                            isValidPass={isValidPass}
                                            setBirthYearValidation={setBirthYearValidation}
                                            setBirthDayMonthValidation={setBirthDayMonthValidation}
                                            setIsValidPass={setIsValidPass}
                                            submitButtonValidations={submitButtonValidations}
                                        />

                                        {userProfile.investmentType === CREDIT_CARD ? (
                                            <>
                                                <LegalInfo />
                                                {mustShowInfoAnotherAccount() && (
                                                    <FormattedText
                                                        value="field-infoAnotherAccount"
                                                        className="initialstep-container__info-another-account"
                                                    />
                                                )}
                                                <div className="row">
                                                    <div className="col-sm-12 check-box__legal">
                                                        <CheckBox
                                                            listClassName="field_acceptClause"
                                                            profileModel="userProfile.acceptTerms"
                                                            fieldsRequired="1"
                                                            checkBoxList={[
                                                                {
                                                                    label: (
                                                                        <FormattedText value="field-acceptClausuleCreditCard" />
                                                                    ),
                                                                    model: 'userProfile.acceptTerms',
                                                                    onChange: e => {
                                                                        setIsReaded(e);
                                                                    },
                                                                },
                                                            ]}
                                                            userProfile={userProfile}
                                                            userProfileForm={userProfileForm}
                                                            formActions={formActions}
                                                            remarkable={true}
                                                            checked={true}
                                                            messagesError={{
                                                                required: formatText(
                                                                    'validation-fieldRequiredDataProtectionClause'
                                                                ),
                                                            }}
                                                            errorStyle="form__field_error_remarkable"
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div ref={documentsRef} id="documentationModalRow">
                                                <Documentation
                                                    profileOnboardingType={userProfile.onboardingType}
                                                    isDocumentsLoaded={userProfile.precontractualDocsOK}
                                                    getDocuments={getDocuments}
                                                    precontractualDocNames={userProfile.precontractualDocNames}
                                                    onDocumentAcceptance={saveTimeDocAccept}
                                                    onClose={scrollToDocModalRow}
                                                />
                                            </div>
                                        )}
                                        {mustShowInfoAnotherAccount() && (
                                            <div className="mt-20">
                                                <FormattedText
                                                    value="field-infoAnotherAccount"
                                                    className="initialstep-container__info-another-account"
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <ResidentContainer
                                hiddenResidentContainer={hiddenResidentContainer}
                                handleOnClick={onHandleClickRedirects}
                                id="countryRestriction"
                            />
                            <OlderContainer
                                hiddenOlderContainer={hiddenOlderContainer}
                                handleOnClick={onHandleClickRedirects}
                                id="ageRestriction"
                            />
                            <JointHolderContainer
                                hiddenJointHolderContainer={hiddenJointHolderContainer}
                                handleOnClick={onHandleClickRedirects}
                                id="JointHolderContainer"
                            />
                            {renderTermsAndConditions()}
                            {userProfile?.universiaName && (
                                <AlertWarning title="initial-reuseDataTitle" description="initial-reuseDataText" />
                            )}
                        </div>
                        <div className={showContinueBar === true ? 'form__footer' : 'form__footer-hidden'}>
                            <div className="form__buttons">
                                {!onSubmit.disabled ? (
                                    <button type="submit" className={classNameButtonSubmit} {...onSubmit}>
                                        <FormattedText value={button} />
                                    </button>
                                ) : (
                                    <button onClick={handleValidation} className="form__button disable-styles">
                                        <FormattedText value={button} />
                                    </button>
                                )}
                                <ModalBox
                                    bsSize="large"
                                    mainAction={() => (window.location.href = PUBLICA_URL)}
                                    defaultOpen={showModal}
                                    openButton={false}
                                    className="form__button form__button-primary"
                                    textButton=""
                                    modalTitle={formatText('boxes-cancelProcess')}
                                    textButtonClose={<FormattedText value="button-continueProcess" />}
                                    textButtonMainAction={<FormattedText value="button-cancelProcess" />}
                                    classNameMainButton="form__button-secondary"
                                >
                                    <p>{formatText('boxes-cancelProcessDescription')}</p>
                                </ModalBox>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
};

InitialStepFormComponent.propTypes = {
    formActions: PropTypes.object,
    actions: PropTypes.object,
    userProfile: PropTypes.object,
    userProfileForm: PropTypes.object,
    onSubmit: PropTypes.object,
    focusActions: PropTypes.object,
    flags: PropTypes.object,
    promotionalCode: PropTypes.object,
    props: PropTypes.object,
    form: PropTypes.object,
    focus: PropTypes.object,
    immStepsState: PropTypes.object,
    productsActions: PropTypes.object,
    promoCode: PropTypes.string,
    readyCaptchaToken: PropTypes.func,
    preLoaderActions: PropTypes.object,
    renderTermsAndConditions: PropTypes.func,
    scoringActions: PropTypes.object,
    wealthProduct: PropTypes.object,
    products: PropTypes.object,
    children: PropTypes.node,
};
